import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface ISingleNeedComment extends BaseEntity {
    Comment: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
}

export class SingleNeedComment implements ISingleNeedComment {
    Id: string;
    Comment: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;

    constructor() {
        this.Id = '';
        this.Comment = '';
    }
}
